import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ERROR_CODE, ERROR_CODE_ZH } from '../../constants/login';
import { sendVerifyCode, updatePhone } from '../../service/login';
import { useMsgFail } from '../../utils/antd-message';
import { encryptStr } from '../../utils/encryp';
import { phoneReg } from '../../utils/phone';
import './index.less';
import '../../styles/input.less';
import { formatCode, formatPhone, onNumberInputChange } from '../..';
import { BtnSave } from '../personal-data/components/btn-save';
import { useStatistics } from '../../utils/statistics';
export function ChangePhone(_ref) {
  var style = _ref.style,
    className = _ref.className,
    onClick = _ref.onClick,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError,
    userPhone = _ref.userPhone,
    active = _ref.active;
  useStatistics('ChangePhone');
  var MsgFail = useMsgFail();
  var _useState = useState('获取验证码'),
    _useState2 = _slicedToArray(_useState, 2),
    verifyText = _useState2[0],
    setVerifyText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    verifyDisabled = _useState4[0],
    setVerifyDisabled = _useState4[1];
  var _useState5 = useState('获取验证码'),
    _useState6 = _slicedToArray(_useState5, 2),
    newVerifyText = _useState6[0],
    setNewVerifyText = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    newVerifyDisabled = _useState8[0],
    setNewVerifyDisabled = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    phone = _useState10[0],
    setPhone = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    code = _useState12[0],
    setCode = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    codeErr = _useState14[0],
    setCodeErr = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    newPhone = _useState16[0],
    setNewPhone = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    newCode = _useState18[0],
    setNewCode = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    newPhoneErr = _useState20[0],
    setNewPhoneErr = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    newCodeErr = _useState22[0],
    setNewCodeErr = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isSaving = _useState24[0],
    setIsSaving = _useState24[1];
  var timer = useRef(0);
  var newTimer = useRef(0);
  var isCodeValid = useMemo(function () {
    return code.length === 6 && !/[^0-9]/.test(code);
  }, [code]);
  var isPhoneValid = useMemo(function () {
    return phoneReg.test(phone);
  }, [phone]);
  var isNewCodeValid = useMemo(function () {
    return newCode.length === 6 && !/[^0-9]/.test(newCode);
  }, [newCode]);
  var isNewPhoneValid = useMemo(function () {
    return phoneReg.test(newPhone);
  }, [newPhone]);
  var resetCode = function resetCode() {
    clearInterval(timer.current);
    setVerifyDisabled(false);
    setVerifyText('获取验证码');
  };
  var resetNewCode = function resetNewCode() {
    clearInterval(newTimer.current);
    setNewVerifyDisabled(false);
    setNewVerifyText('获取验证码');
  };
  var handleSendCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var encrypPhone, seconds, _e$response, _e$response$data, text, _e$response2, _e$response2$data, _e$response3, _e$response3$data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(verifyDisabled || !isPhoneValid)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            encrypPhone = encryptStr(phone);
            _context.next = 6;
            return sendVerifyCode({
              phone: encrypPhone
            });
          case 6:
            setVerifyDisabled(true);
            seconds = 60;
            setVerifyText("".concat(seconds, " \u79D2\u540E\u91CD\u8BD5"));
            timer.current = window.setInterval(function () {
              seconds--;
              setVerifyText("".concat(seconds, " \u79D2\u540E\u91CD\u8BD5"));
              if (seconds <= 0) {
                resetCode();
              }
            }, 1000);
            _context.next = 19;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            resetCode();
            console.warn(_context.t0);
            text = '';
            if ((_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.code) {
              text = ERROR_CODE_ZH[_context.t0.response.data.code];
              if (((_e$response2 = _context.t0.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.code) === ERROR_CODE.USER_NOT_FOUND) {
                text = '无法设置密码，账号无权限，请联系学校管理员';
              }
            } else {
              text = (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response3 = _context.t0.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : _e$response3$data.message) || '系统错误';
            }
            MsgFail(text);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12]]);
    }));
    return function handleSendCode() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSendNewCode = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var encrypPhone, seconds, _e$response4, _e$response4$data, text, _e$response5, _e$response5$data, _e$response6, _e$response6$data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(newVerifyDisabled || !isNewPhoneValid)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            encrypPhone = encryptStr(newPhone);
            _context2.next = 6;
            return sendVerifyCode({
              phone: encrypPhone
            });
          case 6:
            setNewVerifyDisabled(true);
            seconds = 60;
            setNewVerifyText("".concat(seconds, " \u79D2\u540E\u91CD\u8BD5"));
            newTimer.current = window.setInterval(function () {
              seconds--;
              setNewVerifyText("".concat(seconds, " \u79D2\u540E\u91CD\u8BD5"));
              if (seconds <= 0) {
                resetNewCode();
              }
            }, 1000);
            _context2.next = 19;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            resetNewCode();
            console.warn(_context2.t0);
            text = '';
            if ((_e$response4 = _context2.t0.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.code) {
              text = ERROR_CODE_ZH[_context2.t0.response.data.code];
              if (((_e$response5 = _context2.t0.response) === null || _e$response5 === void 0 ? void 0 : (_e$response5$data = _e$response5.data) === null || _e$response5$data === void 0 ? void 0 : _e$response5$data.code) === ERROR_CODE.USER_NOT_FOUND) {
                text = '无法设置密码，账号无权限，请联系学校管理员';
              }
            } else {
              text = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_e$response6 = _context2.t0.response) === null || _e$response6 === void 0 ? void 0 : (_e$response6$data = _e$response6.data) === null || _e$response6$data === void 0 ? void 0 : _e$response6$data.message) || '系统错误';
            }
            MsgFail(text);
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 12]]);
    }));
    return function handleSendNewCode() {
      return _ref3.apply(this, arguments);
    };
  }();
  var onOkError = function onOkError(msg) {
    var text = msg;
    // if (text) {
    //   // text = ERROR_CODE_ZH[resCode]
    //   // if (resCode === ERROR_CODE.WRONG_VERIFICATION) {
    //   //   text = '原账号手机号或验证码不正确'
    //   // }
    //   // if (resCode === ERROR_CODE.NEW_PHONE_WRONG_VERIFICATION) {
    //   //   text = '新账号手机号或验证码不正确'
    //   // }
    // } else {
    //   text = '系统错误'
    // }
    if (!text) {
      text = '系统错误';
    }
    MsgFail(text);
  };
  var handleOk = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _yield$updatePhone, _yield$updatePhone$da, httpCode, message, _e$response7, _e$response7$data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            if (!(isCodeValid && isPhoneValid && isNewCodeValid && isNewPhoneValid && !isSaving)) {
              _context3.next = 11;
              break;
            }
            setIsSaving(true);
            _context3.next = 5;
            return updatePhone({
              phone: encryptStr(phone),
              verification: encryptStr(code),
              newPhone: encryptStr(newPhone),
              newVerification: encryptStr(newCode)
            });
          case 5:
            _yield$updatePhone = _context3.sent;
            _yield$updatePhone$da = _yield$updatePhone.data;
            httpCode = _yield$updatePhone$da.code;
            message = _yield$updatePhone$da.message;
            if (httpCode === '0') {
              onSuccess && onSuccess();
            } else {
              onOkError(message);
              onError && onError(httpCode);
            }
            setIsSaving(false);
          case 11:
            _context3.next = 19;
            break;
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](0);
            setIsSaving(false);
            console.warn(_context3.t0);
            onOkError(_context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_e$response7 = _context3.t0.response) === null || _e$response7 === void 0 ? void 0 : (_e$response7$data = _e$response7.data) === null || _e$response7$data === void 0 ? void 0 : _e$response7$data.message);
            onError && onError(_context3.t0);
          case 19:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 13]]);
    }));
    return function handleOk() {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (userPhone) {
      setPhone(userPhone);
    }
  }, [userPhone]);
  useEffect(function () {
    return function () {
      clearInterval(timer.current);
      clearInterval(newTimer.current);
    };
  }, []);
  useEffect(function () {
    if (!active) {
      resetCode();
      resetNewCode();
      setCode('');
      setCodeErr('');
      setNewPhone('');
      setNewCode('');
      setNewPhoneErr('');
      setNewCodeErr('');
    }
  }, [active]);
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    onClick: onClick,
    className: "".concat(className, " login-change-phone")
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-change-phone-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-change-phone-tips"
  }, "\u5B8C\u6210\u8D26\u53F7\u5B89\u5168\u9A8C\u8BC1\u540E\uFF0C\u53EF\u4FEE\u6539\u624B\u673A\u53F7"), /*#__PURE__*/React.createElement("div", {
    className: "login-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-phone",
    value: formatPhone(phone),
    type: "text",
    readOnly: true,
    placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7"
  })), /*#__PURE__*/React.createElement("div", {
    className: "login-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-code",
    onBlur: function onBlur(e) {
      var inputCode = e.target.value.replace(/[^0-9]/g, '');
      if (inputCode.length === 0) {
        setCodeErr('请输入验证码');
      } else if (inputCode.length !== 6 || /[^0-9]/.test(inputCode)) {
        setCodeErr('验证码为6位数字');
      } else {
        setCodeErr('');
      }
    },
    value: formatCode(code),
    onChange: function onChange(e) {
      onNumberInputChange(e, 6, setCode);
    },
    type: "text",
    placeholder: "\u8BF7\u8F93\u51656\u4F4D\u9A8C\u8BC1\u7801"
  }), /*#__PURE__*/React.createElement("span", {
    style: !isPhoneValid || verifyDisabled ? {
      cursor: 'not-allowed',
      minWidth: '80px'
    } : {},
    className: "login-input-sendCode ".concat(!(!isPhoneValid || verifyDisabled) ? 'active' : ''),
    onClick: handleSendCode
  }, verifyText), /*#__PURE__*/React.createElement("div", {
    className: "login-input-text-error"
  }, codeErr)), /*#__PURE__*/React.createElement("div", {
    className: "login-change-phone-tips",
    style: {
      marginTop: '12px'
    }
  }, "\u8BF7\u8F93\u5165\u65B0\u7684\u624B\u673A\u53F7\u53CA\u9A8C\u8BC1\u7801\uFF0C\u4E0B\u6B21\u767B\u5F55\u8BF7\u4F7F\u7528\u65B0\u7684\u624B\u673A\u53F7"), /*#__PURE__*/React.createElement("div", {
    className: "login-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-phone",
    onBlur: function onBlur(e) {
      var inputPhone = e.target.value.replace(/[^0-9]/g, '');
      if (inputPhone.length === 0) {
        setNewPhoneErr('请输入手机号');
      } else if (!phoneReg.test(inputPhone)) {
        setNewPhoneErr('手机号格式错误');
      } else {
        setNewPhoneErr('');
      }
    },
    value: formatPhone(newPhone),
    type: "text",
    onChange: function onChange(e) {
      onNumberInputChange(e, 11, setNewPhone);
    },
    placeholder: "\u8BF7\u8F93\u5165\u65B0\u7684\u624B\u673A\u53F7"
  }), /*#__PURE__*/React.createElement("div", {
    className: "login-input-text-error"
  }, newPhoneErr)), /*#__PURE__*/React.createElement("div", {
    className: "login-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-code",
    onBlur: function onBlur(e) {
      var inputCode = e.target.value.replace(/[^0-9]/g, '');
      if (inputCode.length === 0) {
        setNewCodeErr('请输入验证码');
      } else if (inputCode.length !== 6 || /[^0-9]/.test(inputCode)) {
        setNewCodeErr('验证码为6位数字');
      } else {
        setNewCodeErr('');
      }
    },
    value: formatCode(newCode),
    onChange: function onChange(e) {
      onNumberInputChange(e, 6, setNewCode);
    },
    type: "text",
    placeholder: "\u8BF7\u8F93\u51656\u4F4D\u9A8C\u8BC1\u7801"
  }), /*#__PURE__*/React.createElement("span", {
    style: !isNewPhoneValid || newVerifyDisabled ? {
      cursor: 'not-allowed',
      minWidth: '80px'
    } : {},
    className: "login-input-sendCode ".concat(!(!isNewPhoneValid || newVerifyDisabled) ? 'active' : ''),
    onClick: handleSendNewCode
  }, newVerifyText), /*#__PURE__*/React.createElement("div", {
    className: "login-input-text-error"
  }, newCodeErr)), /*#__PURE__*/React.createElement(BtnSave, {
    confirmDisabled: !(isCodeValid && isPhoneValid && isNewCodeValid && isNewPhoneValid),
    onConfirm: handleOk,
    isSaving: isSaving
  })));
}